import useFormatter from "@/hooks/use-formatter.hook.ts";
import { TaskViewModal } from "@/pages/tasks/widgets/TaskViewModal.tsx";
import { ApiTask, ApiTaskStatus } from "@/types/task.types.ts";
import {
  Avatar,
  Button,
  FontAwesomeIcon,
  ListItem,
  Stack,
  Tag,
  Text,
  useModals,
} from "@skailer-com/uikit";
import { useTranslation } from "react-i18next";
import { twMerge } from "tailwind-merge";

export const TaskRow = ({ task }: { task: ApiTask }) => {
  const { t } = useTranslation();

  const isCompleted = task.status === ApiTaskStatus.completed;
  const isInProgress = task.status === ApiTaskStatus.in_progress;
  const { renderEmployeeName } = useFormatter();
  const { openModal } = useModals();
  const handleViewTask = (task: ApiTask) => {
    openModal(TaskViewModal, { task });
  };

  let caption: string | undefined;
  if (task.created_by) {
    caption = t("tasks:from_employee", { name: renderEmployeeName(task.created_by) });
  } else if (task.created_by_workflow) {
    caption = t("tasks:from_workflow", { title: task.created_by_workflow.title });
  }

  return (
    <ListItem
      icon={
        isCompleted ? (
          <Avatar
            color={"positive"}
            colorStyle={"solid"}
            icon={<FontAwesomeIcon icon="fa-light fa-check" className="text-white" />}
          />
        ) : (
          <Avatar icon={<FontAwesomeIcon icon="fa-light fa-check" />} />
        )
      }
      titleSlot={
        <Text className={twMerge("font-semibold", isCompleted ? "text-secondary" : "")}>
          {task.related_employee
            ? `${task.title} (${renderEmployeeName(task.related_employee)})`
            : task.title}
        </Text>
      }
      caption={caption}
      valueSlot={
        <Stack direction={"horizontal"} gap={"sm"} items={"center"}>
          {isInProgress && <Tag variant={"new"}>{t("tasks:task_status_in_progress")}</Tag>}
          <Button
            variant="plain"
            rightIcon={<FontAwesomeIcon icon="fa-light fa-chevron-right" />}
            onClick={() => handleViewTask(task)}
          >
            <Text className={"font-semibold"}>{t("tasks:view_task")}</Text>
          </Button>
        </Stack>
      }
      behavior={"card"}
    />
  );
};
